import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MailboxConfiguration } from '@work4all/models/lib/Classes/MailboxConfiguration.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useDataProvider } from '../data-provider/useDataProvider';

const MAILBOX_CONFIGURATION_REQUEST: DataRequest = {
  entity: Entities.mailboxConfiguration,
  data: {
    id: null,
    smtpAddress: null,
    accessValid: null,
  } as MailboxConfiguration,
  completeDataResponse: true,
};

export const useMailboxConfigurationVerifier = () => {
  const { t } = useTranslation();
  const response = useDataProvider(MAILBOX_CONFIGURATION_REQUEST);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const invalidEmails = response.data?.filter((data) => !data.accessValid);
    if (invalidEmails && invalidEmails.length > 0) {
      enqueueSnackbar(
        t('ERROR.EMAIL_NOT_CONNECTED', {
          email: invalidEmails.map((e) => e.smtpAddress).join(', '),
        }),
        {
          variant: 'warning',
        }
      );
    }
  }, [response, t, enqueueSnackbar]);
};
